import { setColorScheme } from "../externals/theme";
import useEnv from "../queries/use-env";

const useSetColorScheme = () => {
  const env = useEnv();
  setColorScheme(env.customerGroupConfig.colorScheme);
};

export default useSetColorScheme;
